import { getState, setState, removeState } from "@/utils/localStore";
const ID_TOKEN_KEY = "tc_online_prod_reg_id_token";


export const getToken = () => {
  return getState(ID_TOKEN_KEY);
};

export const saveToken = token => {
  setState(ID_TOKEN_KEY, token);
};

export const removeToken = () => {
  removeState(ID_TOKEN_KEY);
};

export default { getToken, saveToken, removeToken };
